import { ApiCall } from '@/api/ApiCall';
import { http } from './http';
import { KeyValue } from '@/types/Common';
import CategoryData = App.Data.CategoryData;
import NewRecordResponse = App.Data.NewRecordResponse;
import SavedRecordResponse = App.Data.SavedRecordResponse;
import CategoryAttributeData = App.Data.CategoryAttributeData;
import CategoryCompactData = App.Data.CategoryCompactData;

export const poolTask = (task) => {
  return ApiCall.create(
    () => {
      return http.get(`task-runner/${task}`);
    },
    {},
    '',);
};
